export default __webpack_public_path__ + "static/media/Main Fgure.1caa9fc1.png";